import { c as _c } from "react/compiler-runtime";
import Grid from '@precis-digital/kurama/Grid';
import Typography from '@precis-digital/kurama/Typography';
import { useTheme } from '@precis-digital/kurama/utils';
import type { StaticImport } from 'next/dist/shared/lib/get-img-props';
import ThemedImage from 'shared/components/Themed/Image';
import settings from 'public/assets/images/settings.svg';
import tools from 'public/assets/images/tools.svg';
import { type ReactElement } from 'react';
import type { ChartCardErrorType } from '../internalTypes';
import type { ChartCardCustomisationsProps, ChartCardTFunction, ChartDataRow, RequiredAllowUndefined, ViewType } from '../types';
import { getChartCardChartContainerSize, getChartCardTableContainerSize } from '../utils/card';
import { useChartCardDefaults } from '../hooks/useChartCardDefaults';
import StyledCard from './styled/StyledCard';
type ChartCardErrorProps<DataKey extends string, DataRow extends ChartDataRow<DataKey>> = RequiredAllowUndefined<Pick<ChartCardCustomisationsProps<DataKey, DataRow>, 'cardSize' | 'chartSize' | 'tableSize'>> & {
  view: ViewType;
  type: ChartCardErrorType;
  t: ChartCardTFunction;
};
const errorAsset: Record<ChartCardErrorType, StaticImport> = {
  noData: settings,
  noMetrics: settings,
  noDimensions: settings,
  dataError: tools
};
const ChartCardError = t0 => {
  const $ = _c(29);
  const {
    view,
    cardSize,
    chartSize,
    tableSize,
    type,
    t
  } = t0;
  const defaults = useChartCardDefaults();
  const theme = useTheme();
  let t1;
  if ($[0] !== cardSize || $[1] !== chartSize || $[2] !== tableSize || $[3] !== view) {
    t1 = view === "table" ? getChartCardTableContainerSize({
      view,
      cardSize,
      tableSize
    }) : getChartCardChartContainerSize({
      view,
      cardSize,
      chartSize
    });
    $[0] = cardSize;
    $[1] = chartSize;
    $[2] = tableSize;
    $[3] = view;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const {
    containerWidth,
    containerHeight
  } = t1;
  const addedWidth = defaults.card.padding * 2;
  const addedHeight = defaults.card.padding * 2 + defaults.table.height.title + defaults.card.gap;
  const width = typeof containerWidth === "string" ? containerWidth : `calc(${containerWidth}px + ${addedWidth}px)`;
  const height = typeof containerHeight === "string" ? containerHeight : `calc(${containerHeight}px + ${addedHeight}px)`;
  const asset = errorAsset[type];
  const t2 = defaults.card.padding;
  let t3;
  if ($[5] !== theme) {
    t3 = theme.spacing(5);
    $[5] = theme;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== asset) {
    t4 = <ThemedImage src={asset} alt="settings" width={53} />;
    $[7] = asset;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const t5 = `${type}Title`;
  let t6;
  if ($[9] !== t || $[10] !== t5) {
    t6 = t(t5);
    $[9] = t;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t6) {
    t7 = <Typography variant="h5">{t6}</Typography>;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  const t8 = `${type}Body`;
  let t9;
  if ($[14] !== t || $[15] !== t8) {
    t9 = t(t8);
    $[14] = t;
    $[15] = t8;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== t9) {
    t10 = <Typography variant="body3">{t9}</Typography>;
    $[17] = t9;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== t10 || $[20] !== t7) {
    t11 = <Grid container={true} direction="column" alignItems="center" maxWidth={400} textAlign="center">{t7}{t10}</Grid>;
    $[19] = t10;
    $[20] = t7;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] !== defaults.card.padding || $[23] !== height || $[24] !== t11 || $[25] !== t3 || $[26] !== t4 || $[27] !== width) {
    t12 = <StyledCard><Grid container={true} direction="column" alignItems="center" justifyContent="center" padding={t2} gap={t3} width={width} height={height}>{t4}{t11}</Grid></StyledCard>;
    $[22] = defaults.card.padding;
    $[23] = height;
    $[24] = t11;
    $[25] = t3;
    $[26] = t4;
    $[27] = width;
    $[28] = t12;
  } else {
    t12 = $[28];
  }
  return t12;
};
export default ChartCardError;